<template>
  <info>
    <h1>{{ $t("APIS") }}</h1>
    <h2>{{ $t("MAIN API") }}</h2>
    <p
      v-html="
        $t('WHAT_CAN_APIS_DO', {
          documentationLink:
            'https://api.dbservices.to/v1.7/spec/',
        })
      "
    ></p>
    <h2>{{ $t("STATUS_API") }}</h2>
    <p
      v-html="
        $t('STATUS_API_DESC', {
          statusLink:
            'https://status.dbservices.to/API/v1.0/spec/',
        })
      "
    ></p>

    <template slot="sidebar">
      <h2>{{ $t("TERMS OF USE FOR APIS") }}</h2>
      <p
        v-html="
          $t('TOS_API_DESC')
        "
      ></p>
    </template>
  </info>
</template>

<script>
import Info from '@/components/Info';

export default {
  components: { Info },
  computed: {
    title() {
      return this.$t('APIS');
    },
  },
};
</script>
